import React, { useMemo } from 'react';
import { SingleSelectMenu } from '../../../../Dropdown';
import { singleDayAllValue } from '../../../../../utils/builder';
import { IRetentionHeader } from '../../../interfaces';
import { getHeaderName } from '../../../../../utils/redux/transformRetentionData';

interface IProps {
  singleDayLabel: string;
  value: string;
  onChange: (selectedValue: string) => void;
  rowHeaders: IRetentionHeader[];
}
export default ({ value, onChange, rowHeaders, singleDayLabel }: IProps) => {
  const options = useMemo(() => {
    return [
      {
        value: singleDayAllValue,
        text: singleDayLabel,
      },
      ...rowHeaders.map((rowHeader) => ({
        value: rowHeader.key,
        text: getHeaderName(rowHeader),
      })),
    ];
  }, [rowHeaders, singleDayLabel]);

  return (
    <SingleSelectMenu
      options={options}
      value={value || singleDayAllValue}
      onChange={onChange}
    />
  );
};
